import MeetRovoBanner from '../assets/productAssets/MeetRovoBanner.svg';
import RovoUseCaseOne from '../assets/productAssets/RovoUseCaseOne.png';
import RovoUseCaseThree from '../assets/productAssets/RovoUseCaseThree.png';
import RovoUseCaseTwo from '../assets/productAssets/RovoUseCaseTwo.png';

interface MeetRovoSectionActionsConfigType {
  heading: string;
  description: string;
  actions: { id: string; logo: string; heading: string; description: string }[];
}

interface MeetRovoSectionBannerConfigType {
  heading: string;
  description: string;
  ctaText: string;
  ctaAriaLabel?: string;
  image: string;
  ctaLink: string;
}

const MeetRovoSectionBannerConfig: MeetRovoSectionBannerConfigType = {
  heading: 'Rovo: AI that knows your business',
  description:
    'Rovo is Atlassian’s AI for teamwork that connects every app, every team, and every workflow. It helps people find answers, make decisions, and automate work—securely and with context—through Search, Chat, Agents, and Studio.',
  ctaText: 'Explore Rovo-powered apps',
  ctaLink: '/collections/atlassian-rovo',
  ctaAriaLabel: 'Explore Rovo-powered apps',
  image: MeetRovoBanner,
};

const MeetRovoSectionActionsConfig: MeetRovoSectionActionsConfigType = {
  heading: 'Bring Rovo into every workflow',
  description:
    'Rovo understands your company inside out, plugs into every app you use, and always shows up wherever work is happening.',
  actions: [
    {
      id: '1',
      logo: RovoUseCaseOne,
      heading: 'Search',
      description: 'Get information when you need it, not when you find it.',
    },
    {
      id: '2',
      logo: RovoUseCaseTwo,
      heading: 'Chat',
      description: 'Dig deeper and take action faster, in the right direction.',
    },
    {
      id: '3',
      logo: RovoUseCaseThree,
      heading: 'Agents',
      description: 'Team up with Agents, ready to tackle any task smarter and faster.',
    },
  ],
};

export { MeetRovoSectionActionsConfig, MeetRovoSectionBannerConfig };
